<gbc-page-error-handler [content]="content" [pageError$]="pageError$"></gbc-page-error-handler>
<ng-template #content>
  <gbc-command-spinner>
    @if (pageInfo$ | async; as pageInfo) {
      <gbc-page-header [pageInfo]="pageInfo">
        @if (!(isArchived$ | async)) {
          <ng-container gbc-page-header-actions>
            <button gbc-text-button (click)="editFacility()">
              <img style="margin-right: 10px" src="./assets/svgs/edit.svg" alt="Edit" />
              {{ 'app-edit' | translate }}
            </button>
            <button gbc-text-button (click)="confirmArchiveFacility()">
              <img style="margin-right: 10px" src="./assets/svgs/archive.svg" alt="Archive" />
              {{ 'app-archive' | translate }}
            </button>
          </ng-container>
        }
        @if (facility$ | async; as facility) {
          <ng-container gbc-page-header-right>
            @if (showCreateInstallationButton$ | async) {
              <button
                gbc-button
                [routerLink]="[createInstallationUrlMap[facility.facilityType]]"
          [queryParams]="{
            companyId: facility.company.id,
            facilityId: facility.id
          }"
                >
                {{ 'facility-page.create-installation' | translate }}
              </button>
            }
            @if (showCreateUserButton$ | async) {
              <button
                gbc-button
                [routerLink]="['/users/create']"
          [queryParams]="{
            companyId: facility.company.id,
            facilityId: facility.id
          }"
                >
                {{ 'facility-page.create-user' | translate }}
              </button>
            }
          </ng-container>
        }
      </gbc-page-header>
    }
    <gbc-tabs>
      <gbc-tab [title]="'facility-page.installations' | translate" name="installations">
        <gbc-page-container>
          @if (facility$ | async; as facility) {
            <gbc-tile
              [title]="'facility-page.facility-information' | translate"
              style="padding-bottom: 0"
              >
              <gbc-input-container>
                <gbc-input-label>{{ 'facility-page.name' | translate }}*</gbc-input-label>
                <gbc-input-field [disabled]="true" [(ngModel)]="facility.name" name="name"></gbc-input-field>
              </gbc-input-container>
              <gbc-input-container>
                <gbc-input-label>{{ 'facility-page.address' | translate }}*</gbc-input-label>
                <gbc-input-field [disabled]="true" [(ngModel)]="facility.addressRoad" name="address"></gbc-input-field>
              </gbc-input-container>
              <gbc-input-container>
                <gbc-input-label>{{ 'facility-page.postal-code' | translate }}*</gbc-input-label>
                <gbc-input-field [disabled]="true" [(ngModel)]="facility.addressPostal" name="postalCode"></gbc-input-field>
              </gbc-input-container>
              <gbc-input-container>
                <gbc-input-label>{{ 'facility-page.city' | translate }}*</gbc-input-label>
                <gbc-input-field [disabled]="true" [(ngModel)]="facility.addressCity" name="city"></gbc-input-field>
              </gbc-input-container>
              <gbc-form-hint></gbc-form-hint>
            </gbc-tile>
          }

          <form [formGroup]="form">
            <app-searchbar formControlName="search" [placeholder]="'facility-page.search-for-installation' | translate"> </app-searchbar>
          </form>

          @if (facility$ | async; as facility) {
            <gbc-tile [title]="'facility-page.installations' | translate">
              @if (installations$ | async; as installations) {
                <gbc-table [clickableRows]="true">
                  <th gbc-table-header>
                    {{ 'facility-page.serial-number' | translate }}
                  </th>
                  <th gbc-table-header>
                    {{ 'facility-page.device-id' | translate }}
                  </th>
                  <th gbc-table-header>{{ 'facility-page.status' | translate }}</th>
                  @for (installation of installations; track installation) {
                    @if (isReducedInstallationDTO(installation)) {
                      <tr gbc-table-row (click)="navigateToInstallation(facility, installation)" tabindex="0" (keydown.enter)="navigateToInstallation(facility, installation)">
                        <td gbc-table-cell>{{ installation.serialNumber }}</td>
                        <td gbc-table-cell>{{ installation.deviceId }}</td>
                        <td gbc-table-cell>
                          {{ 'commission-statuses.' + installation.commissionStatus | translate }}
                        </td>
                      </tr>
                    } @else {
                      <tr gbc-table-row (click)="navigateToIGridInstallation(facility, installation)" tabindex="0" (keydown.enter)="navigateToIGridInstallation(facility, installation)">
                        <td gbc-table-cell>{{ installation.serialNumber }}</td>
                        <td gbc-table-cell>{{ installation.deviceId }}</td>
                        <td gbc-table-cell>
                          {{ 'commission-statuses.' + installation.commissionStatus | translate }}
                        </td>
                      </tr>
                    }
                  }
                </gbc-table>
                @if (installations.length === 0) {
                  <p>No installations found.</p>
                  <pre>{{ installations && installations.length === 0 ? '' : installations ? installations : '' }}</pre>
                }
              }
            </gbc-tile>
          }
        </gbc-page-container>
      </gbc-tab>

      <gbc-tab [title]="'facility-page.users' | translate" name="users">
        <gbc-page-container>
          <app-users-list></app-users-list>
        </gbc-page-container>
      </gbc-tab>
    </gbc-tabs>
  </gbc-command-spinner>
</ng-template>
